import React, { useEffect, useRef } from "react";
import getStyled from "../../../../hooks/getStyled";
import { SFDragHandleIcon } from "../../../icons";

const { styled } = getStyled();

const StyledContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  cursor: "pointer"
}));

const SFRowDraggingRenderer = (props) => {
  const dragRef = useRef(null);

  useEffect(() => {
    props.registerRowDragger(dragRef.current);
  });

  return (
    <StyledContainer ref={dragRef}>
      <SFDragHandleIcon />
    </StyledContainer>
  );
};

export default SFRowDraggingRenderer;
